import React, { useState } from "react";
import { Card } from "react-bootstrap";
import "../../assets/css/addCredits.scss"

function AddCreditsCard({ plan, billingType, selectedPlanDetail, setSelectedAddCredits, selectedAddCredits }) {

    const creditOptions = [
        { text: "0/mo", credits: "0", cost: "0" },
        { text: "500/mo", credits: "500", cost: "10" },
        { text: "1K/mo", credits: "1000", cost: "20" },
        { text: "2.5K/mo", credits: "2500", cost: "50" },
        { text: "5K/mo", credits: "5000", cost: "100" },
        { text: "10K/mo", credits: "10000", cost: "185" },
        // { text: "20K/mo", credits: "20000", cost: "325" },
        // { text: "50K/mo", credits: "50000", cost: "800" },
        // { text: "100K/mo", credits: "100000", cost: "1600" },
        // { text: "250K/mo", credits: "250000", cost: "3750" }
    ];

    const [selectedIndex, setSelectedIndex] = useState(0);

    const formatCredits = (credits) => {
        const num = Number(credits);

        if (num >= 1000000) {
            return `${(num / 1000000).toFixed(1).replace('.0', '')}M`;
        }

        if (num >= 1000) {
            return `${(num / 1000).toFixed(1).replace('.0', '')}K`;
        }

        return num;
    };

    const selectedCreditIndex = (index) => {
        setSelectedIndex(index);
        creditOptions.forEach((item, i) => {
            if (i === index) {
                setSelectedAddCredits(item);
                selectedPlanDetail(billingType, plan, item);
            }
        })
    }

    return (

        <Card className="add-credit-card">

            <Card.Body>

                <div className="credit-box">

                    <h5>
                        Credits
                    </h5>

                    <p>
                        Credits are shared across users.
                        Select how many credits you would
                        like for your team below.
                    </p>

                    <div className="credit-top">

                        <div className="credit-title">
                            {plan ? <>{formatCredits(plan.credits.replace(/[^0-9]/g, ""))} {selectedAddCredits?.credits ? `+ ${formatCredits(selectedAddCredits?.credits.toString())} credits/mo` : `+ 0`}</> : `+ 0`}
                        </div>

                        <div className="credit-price">
                            {selectedAddCredits?.cost ? `$${selectedAddCredits?.cost}/mo` : `0/mo`}
                        </div>

                    </div>

                    <div className="slider-wrapper">

                        <input
                            type="range"
                            min="0"
                            max={creditOptions.length - 1}
                            value={selectedIndex}
                            onChange={(e) =>
                                selectedCreditIndex(Number(e.target.value))
                            }
                            className="credit-slider"
                            style={{
                                background: `linear-gradient(
                                    90deg,
                                    #0d6efd 0%,
                                    #0d6efd ${(selectedIndex /
                                        (creditOptions.length - 1)) *
                                    100
                                    }%,
                                    #555 ${(selectedIndex /
                                        (creditOptions.length - 1)) *
                                    100
                                    }%,
                                    #555 100%
                                )`
                            }}
                        />

                        <div className="slider-labels">

                            {creditOptions.map((item, index) => (

                                <span
                                    key={index}
                                    className={
                                        selectedIndex === index
                                            ? "active-label"
                                            : ""
                                    }
                                >
                                    {item.text}
                                </span>

                            ))}

                        </div>

                    </div>

                </div>

            </Card.Body>

        </Card>
    );
}

export default AddCreditsCard;